import { render, staticRenderFns } from "./CarInfoItem.vue?vue&type=template&id=06e585e0&"
import script from "./CarInfoItem.vue?vue&type=script&lang=js&"
export * from "./CarInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./CarInfoItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports